module.exports = __webpack_public_path__ + "static/media/Hero_Image_Mobile_2.7b377650.jpg";